module.exports = __webpack_public_path__ + "img/logo_eestec_olympics_10.12e99635.png";